"use strict";
var Trigger_1 = require('../Trigger');
var SchemaStore_1 = require('../SchemaStore');
var GroupStore_1 = require('../GroupStore');
var extend = require('extend');
var camelize = require('camelize');
var OptionsParser = (function () {
    function OptionsParser() {
    }
    OptionsParser.fromLiteral = function (opts) {
        var _this = this;
        var result = {};
        if (opts) {
            Object.keys(opts).forEach(function (key) {
                var value = opts[key];
                switch (key) {
                    case 'trigger':
                        value = _this.parseTriggers(value);
                        break;
                    case 'placementOffset':
                    case 'alignmentOffset':
                    case 'viewportPadding':
                    case 'timeToHoverOnPop':
                    case 'showDelay':
                    case 'fadeDuration':
                    case 'cushion':
                    case 'containerCushion':
                        value = parseFloat(value);
                        break;
                    case 'optimizePlacement':
                    case 'transitionPlacement':
                    case 'disableClickOff':
                    case 'darkStyle':
                    case 'disable':
                    case 'reusePopover':
                        value = typeof value === 'string' ? value === 'true' : !!value;
                        break;
                }
                result[key] = value;
            });
        }
        return result;
    };
    OptionsParser.fromElement = function (el) {
        return extend(OptionsParser.fromGroupAttribute(el), OptionsParser.fromSchemaAttribute(el), OptionsParser.fromJSONAttribute(el), OptionsParser.fromSingleAttributes(el));
    };
    OptionsParser.fromSingleAttributes = function (el) {
        var result = {};
        if (el) {
            for (var i = 0; i < el.attributes.length; i++) {
                var attr = el.attributes[i];
                if (attr.name.indexOf('popgun-') === 0) {
                    // this is not picking up camel case..
                    var key = camelize(attr.name.substring(7));
                    if (key !== 'group' && key !== 'schema' && key !== 'json') {
                        result[key] = attr.value;
                    }
                }
            }
        }
        return OptionsParser.fromLiteral(result);
    };
    OptionsParser.fromJSONAttribute = function (el) {
        var json = el.getAttribute('popgun-json');
        if (json) {
            try {
                var parsed = JSON.parse(json);
                if (parsed && parsed.constructor === Object) {
                    return OptionsParser.fromLiteral(parsed);
                }
            }
            catch (e) {
            }
        }
        return {};
    };
    OptionsParser.fromSchemaAttribute = function (el) {
        var schemaId = el.getAttribute('popgun-schema');
        return OptionsParser.fromLiteral(SchemaStore_1.default.get(schemaId));
    };
    OptionsParser.fromGroupAttribute = function (el) {
        var groupId = el.getAttribute('popgun-group');
        return OptionsParser.fromGroupId(groupId);
    };
    OptionsParser.fromGroupId = function (id) {
        var group = GroupStore_1.default.get(id);
        if (group) {
            return OptionsParser.fromLiteral(extend({}, SchemaStore_1.default.get(group.schema), group.options));
        }
        else {
            return {};
        }
    };
    OptionsParser.parseTriggers = function (rawTrigger) {
        if (rawTrigger && typeof rawTrigger === 'string') {
            return rawTrigger.split(/[ ,]+/).map(function (name) { return new Trigger_1.default(name); });
        }
        else {
            return [];
        }
    };
    return OptionsParser;
}());
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = OptionsParser;
